module.exports = __webpack_public_path__ + "img/device1.2981d142.png";